import React from 'react'

const StatusBadge = ({ status, icon }) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'completed':
        return {
          bg: 'bg-[rgba(59,188,76,0.10)]',
          text: 'text-[#3BBC4C]',
          label: 'Completed',
        }
      case 'in progress':
        return {
          bg: 'bg-[rgba(255,186,0,0.10)]',
          text: 'text-[#FFBA00]',
          label: 'In Progress',
        }
      case 'not started':
        return {
          bg: 'bg-[rgba(160,174,192,0.10)]', // light gray
          text: 'text-[#A0AEC0]', // gray
          label: 'Not Started',
        }
      default:
        return {
          bg: 'bg-[rgba(160,174,192,0.10)]',
          text: 'text-[#A0AEC0]',
          label: 'Not Started',
        }
    }
  }

  const { bg, text, label } = getStatusStyles()

  return (
    <div
      className={`flex items-center gap-1 ${bg} w-fit px-2 py-1.5 rounded-[20px]`}
    >
      {icon ? (
        <div>{icon}</div>
      ) : status === 'completed' ? (
        <div>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_256_14291)">
              <path
                d="M7 13.5625C3.38144 13.5625 0.4375 10.6186 0.4375 7C0.4375 3.38144 3.38144 0.4375 7 0.4375C10.6186 0.4375 13.5625 3.38144 13.5625 7C13.5625 10.6186 10.6186 13.5625 7 13.5625ZM7 1.3125C3.864 1.3125 1.3125 3.864 1.3125 7C1.3125 10.136 3.864 12.6875 7 12.6875C10.136 12.6875 12.6875 10.136 12.6875 7C12.6875 3.864 10.136 1.3125 7 1.3125ZM6.43431 9.05931L10.3718 5.12181C10.5429 4.95075 10.5429 4.67425 10.3718 4.50319C10.2008 4.33213 9.92425 4.33213 9.75319 4.50319L6.125 8.13138L4.68431 6.69069C4.51325 6.51963 4.23675 6.51963 4.06569 6.69069C3.89463 6.86175 3.89463 7.13825 4.06569 7.30931L5.81569 9.05931C5.901 9.14463 6.013 9.1875 6.125 9.1875C6.237 9.1875 6.349 9.14463 6.43431 9.05931Z"
                fill="#3BBC4C"
                stroke="#3BBC4C"
                strokeWidth="0.25"
              ></path>
            </g>
            <defs>
              <clipPath id="clip0_256_14291">
                <rect width="14" height="14" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>
        </div>
      ) : null}
      <div className={`${text} text-xs leading-3`}>{label}</div>
    </div>
  )
}

export default StatusBadge
